import axios from 'axios';
import toast from 'react-hot-toast';

// const BASE_URL = 'http://dev.iotcom.io/';
// const BASE_URL = 'https://volente.iotcom.io:8080/';
//const BASE_URL = 'http://pacs.samvaad.io:5500/';
// const BASE_URL = 'http://localhost:5500/';
// const BASE_URL = 'https://supravitest.iotcom.io:8080/node/';
// export const BASE_URL = '${window.location.origin}/node/';
// export const BASE_URL = 'https://app.supravi.ai/node/';
export const BASE_URL = '/node/';
// export const BASE_URL = 'http://127.0.0.1:5500/';

const checkNetworkConnection = () => {
  return navigator.onLine;
};

const handleNetworkError = (error) => {
  if (!checkNetworkConnection()) {
    toast.error('Please check your internet connection.');
    return 'Network Error';
  }
  return error?.response?.data?.message || error.message || 'An error occurred';
};

export const getDataFromServer = async ({ end_point, params, call_back, props }) => {
  if (!checkNetworkConnection()) {
    toast.error('Please check your internet connection.');
    const object = {
      response: undefined,
      status: 'error',
      error: 'Network Error',
      props,
    };
    call_back(object);
    return;
  }

  try {
    const url = BASE_URL + end_point;
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${params?.token}`,
        type: `${params?.type}`,
      },
    });
    const object = {
      response: response.data,
      status: 'success',
      error: undefined,
      props,
    };
    call_back(object);
  } catch (error) {
    const errorMessage = handleNetworkError(error);
    const object = {
      response: undefined,
      status: 'error',
      error: errorMessage,
      props,
    };
    call_back(object);
  }
};

export const postDatatoServer = ({ end_point, body, call_back = () => { }, props = {} }) => {
  if (!checkNetworkConnection()) {
    toast.error('Please check your internet connection.');
    const object = {
      response: undefined,
      status: 'error',
      error: 'Network Error',
      props,
    };
    call_back(object);
    return;
  }

  const headers = props?.token ? { Authorization: `Bearer ${props.token}` } : {};
  const url = BASE_URL + end_point;

  axios
    .post(url, body, { headers })
    .then((response) => {
      const object = {
        response: response.data,
        status: 'success',
        error: undefined,
        props,
      };
      call_back(object);
    })
    .catch((error) => {
      const errorMessage = handleNetworkError(error);
      toast.error(errorMessage);
      const object = {
        response: error,
        status: 'error',
        error: errorMessage,
        props,
      };
      call_back(object);
    });
};

export const uploadImageToServer = async ({ end_point, data, call_back, props }) => {
  if (!checkNetworkConnection()) {
    toast.error('Please check your internet connection.');
    return {
      response: undefined,
      status: 'error',
      error: 'Network Error',
      props,
    };
  }

  try {
    const url = BASE_URL + end_point;
    const formData = new FormData();
    formData.append('file', data, `${props.study}.${data.name.split('.')[data.name.split('.').length - 1]}`);

    const response = await axios.post(url, formData);
    const object = {
      response: response.data,
      status: 'success',
      error: undefined,
      props,
    };
    return object;
  } catch (error) {
    const errorMessage = handleNetworkError(error);
    toast.error(errorMessage);
    return {
      response: undefined,
      status: 'error',
      error: errorMessage,
      props,
    };
  }
};

export const downloadFileServer = async ({ end_point, call_back, props }) => {
  if (!checkNetworkConnection()) {
    toast.error('Please check your internet connection.');
    if (call_back) call_back(false);
    return;
  }

  try {
    const url = BASE_URL + end_point;
    const response = await axios.get(url, { responseType: 'arraybuffer' });
    const fileBlob = new Blob([response.data], { type: 'application/msword' });
    const fileUrl = window.URL.createObjectURL(fileBlob);
    const link = document.createElement('a');
    link.href = fileUrl;
    link.setAttribute('download', props);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    if (call_back) call_back(true);
  } catch (error) {
    const errorMessage = handleNetworkError(error);
    toast.error(errorMessage);
    if (call_back) call_back(false);
  }
};
